import { render } from "./appUser.vue?vue&type=template&id=128afa9e&scoped=true"
import script from "./appUser.vue?vue&type=script&lang=js"
export * from "./appUser.vue?vue&type=script&lang=js"

import "./appUser.vue?vue&type=style&index=0&id=128afa9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128afa9e"]])

export default __exports__